import { Autocomplete, Box, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Table } from '@mui/material'
import React, { useState } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ActionsBar from '../../../components/ActionsBar';
import { FilterAlt } from '@mui/icons-material'
import TextField from '@mui/material/TextField/TextField';
import Paper from '@mui/material/Paper'
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles'
import VoucherItem from './components/VoucherItem';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const Screen = () => {

    const onAddLead = () => {

    }

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
            <ActionsBar title='Danh sách mã giảm giá' subTitle='Tìm thấy: 1000 Lead' addButtonTitle='Thêm KTV' onAddPress={onAddLead} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginLeft: '24px', marginRight: '24px' }}>
                <Box sx={{ display: 'flex' }}>
                    <Box style={{ color: 'blue', display: 'flex', height: '36px', alignItems: 'center', justifyContent: 'center', width: '100px', marginRight: '16px', border: '1px solid #0000ff', borderRadius: '4px' }}>
                        <FilterAlt fontSize='13px' color='blue' />
                        <span style={{ color: 'blue', fontSize: '12px' }}>Bộ lọc</span>
                    </Box>
                    <TextField size='small' style={{ height: '32px', width: '320px' }} placeholder="Tên nhân viên, Email, số điện thoại" />
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <FormControl style={{ width: '180px' }}>
                        <InputLabel id="demo-simple-select-label" style={{ fontSize: '12px', color: 'black' }}>Lọc theo vị trí</InputLabel>
                        <Select
                            label="Tiến trình lead sales"
                        >
                            <MenuItem value={10}>Tổng quản lý</MenuItem>
                            <MenuItem value={20}>Telesale</MenuItem>
                            <MenuItem value={30}>Sale</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>
            <div style={{ display: "flex", width: '100%', overflowY: 'scroll', marginTop: '24px' }}>
                <TableContainer component={Paper} style={{ marginLeft: '24px', marginRight: '24px' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>MÃ CODE</StyledTableCell>
                                <StyledTableCell align="right">Thời gian bắt đầu</StyledTableCell>
                                <StyledTableCell align="right">Thời gian kết thúc</StyledTableCell>
                                <StyledTableCell align="right">{'Chiết khấu %'}</StyledTableCell>
                                <StyledTableCell align="right">{'Chiếu khẩu đ'}</StyledTableCell>
                                <StyledTableCell align="right">{'Số người sử dụng'}</StyledTableCell>
                                <StyledTableCell align="right">Khả dụng?</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
                                <VoucherItem row={row} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    )
}

export default Screen